<div class="db-disable-cdn-dialog">
  <h2 [innerHTML]="title"></h2>
  <p class="mt15 db-desc" [innerHTML]="desc"></p>
  <div class="db-disable-cdn-dialog__checkbox mt15" *ngIf="widthConfirmation">
    <input class="ds-checkbox" type="checkbox" id="agree" [formControl]="agree" (change)="toggle($event)">
    <label for="agree">I have already pointed my DNS records back to the original server IP</label>
  </div>
  <div class="text-right mt30">
    <a class="ds-btn mr20" (click)="close()">
      <span>{{positiveButtonText}}</span>
    </a>
    <a class="ds-btn-red" (click)="!!checked && disableCf()" [ngClass]="{'ds-btn-disabled': loading || !checked}">
      <span *ngIf="!loading">{{negativeButtonText}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>
</div>
